module.exports = __webpack_public_path__ + "img/esp-kobudo-logo.4c5b67b0.png";